<template>
  <div>
    <header class="form-header">
      <div class="headline neutral6-color">
        <slot name="title">Sign up with your networks</slot>
      </div>
    </header>

    <div class="social-buttons-container">
      <slot name="social-buttons"></slot>
    </div>

    <div class="field">
      <label>
        <div class="field-label">First Name</div>
        <cp-text-input class="form-input" name="first_name" v-model="first_name" placeholder="Your first name" block></cp-text-input>
      </label>
    </div>

    <div class="field">
      <label>
        <div class="field-label">Last Name</div>
        <cp-text-input class="form-input" name="last_name" v-model="last_name" placeholder="Your last name" block></cp-text-input>
      </label>
    </div>

    <div class="field">
      <label>
        <div class="field-label">Email</div>
        <cp-text-input type="email" class="form-input" name="email" v-model="email" placeholder="Your Email Address" block></cp-text-input>
      </label>
    </div>

    <div class="field">
      <label>
        <div class="field-label">Phone Number</div>
        <cp-text-input 
          type="tel" 
          class="form-input" 
          name="phone" 
          v-model="phone" 
          placeholder="(###) ###-#### or ###-###-####" 
          block
          :error="phoneError"
        ></cp-text-input>
      </label>
    </div>

    <div class="field">
      <label>
        <div class="field-label">Password</div>
        <cp-text-input type="password" class="form-input" name="password" v-model="password" placeholder="Choose a Password" block></cp-text-input>
      </label>
    </div>

    <div class="field">
      <label class="checkbox-label">
        <input type="checkbox" name="email_subscription_opt_in" v-model="getUpdates" />
        Yes! Sign me up to receive emails from CrowdBlue with daily news, campaigns, and updates.
      </label>
    </div>
  </div>
</template>

<script>
import CpButton from '../button';
import CpTextInput from '../inputs/text';

export default {
  components: {
    CpButton,
    CpTextInput,
  },

  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      password: '',
      getUpdates: true,
      phoneError: '',
    };
  },

  methods: {
    validatePhoneFormat(phone) {
      if (!phone) {
        return '';
      }
      
      const phoneError = this.validatePhone(phone);
      if (phoneError === 'Required') {
        return '';
      }
      
      return phoneError;
    },

    handlePhoneBlur() {
      this.phoneError = this.validatePhoneFormat(this.phone);
    },
  },

  watch: {
    phone() {
      this.phoneError = this.validatePhoneFormat(this.phone);
    },
  },
};
</script>

<style scoped>
.social-buttons-container {
  padding-top: 20px;
}
</style>
